module.exports = __webpack_public_path__ + "img/Announcements.81f6c69a.svg";